import axios from "axios";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Feature } from "ol";
import GeoJSON from "ol/format/GeoJSON";
import Draw from "ol/interaction/Draw";
import Snap from "ol/interaction/Snap";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Text } from "ol/style";
import Circle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import { MyMap } from "../Components/Map/View/MyMap";
import { loading, removeLoading } from "./Alerts2";
import { crosshairCursor } from "./CursorUtils";

const tempLayerSource = new VectorSource({ wrapX: false });

export const tempLayer = new VectorLayer({
  source: tempLayerSource,
  zIndex: 100,
  style: new Style({
    stroke: new Stroke({
      color: "orange",
      width: 5,
    }),
    fill: new Fill({
      color: "rgba(255,255,255,0.2)",
    }),
  }),
  wrapX: false,
});

const styledText = (type, color, text) => {
  return [
    type == "Point"
      ? new Style({
          image: new Circle({
            radius: 6,
            fill: new Fill({ color: "orangered" }),
            stroke: new Stroke({
              color: [0, 0, 0],
              width: 2,
            }),
          }),
          text: new Text({
            font: "12px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            stroke: new Stroke({
              color: "#fff",
              width: 4,
            }),
            text: text,
          }),
        })
      : new Style({
          stroke: new Stroke({
            color: color == undefined ? "orangered" : "rgba(235,235,235,0.6)",
            width: 5,
          }),
          fill: new Fill({
            color: color == undefined ? " rgb(178,34,34,0.3)" : color,
          }),
          text: new Text({
            font: "12px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            stroke: new Stroke({
              color: "#fff",
              width: 4,
            }),
            text: text,
          }),
        }),
  ];
};

const styled = (type, color) => {
  return [
    type == "Point"
      ? new Style({
          image: new Circle({
            radius: 6,
            fill: new Fill({ color: "orangered" }),
            stroke: new Stroke({
              color: [0, 0, 0],
              width: 2,
            }),
          }),
        })
      : new Style({
          stroke: new Stroke({
            color: color == undefined ? "orangered" : "rgba(235,235,235,0.6)",
            width: 5,
          }),
          fill: new Fill({
            color: color == undefined ? " rgb(178,34,34,0.3)" : color,
          }),
        }),
  ];
};

export const addFeatureFromGeojson = (geojson, mapkey) => {
  if (geojson == undefined) {
    return;
  }
  if (geojson == null) {
    return;
  }
  let feature = new Feature({
    geometry: new GeoJSON().readFeature(geojson).getGeometry(),
  });
  if (mapkey != undefined) {
    feature.set("mapkey", mapkey);
  }
  feature.setStyle(styled(feature.getGeometry().getType()));
  tempLayer.getSource().addFeature(feature);
};

export const addPolygonsWithColor = (geojson, color, text, id) => {
  //console.log(geojson,color)
  if (geojson == undefined) {
    return;
  }
  if (geojson == null) {
    return;
  }

  let feature = new Feature({
    geometry: new GeoJSON().readFeature(geojson).getGeometry(),
  });
  feature.set("_id", id);
  feature.setStyle(styledText(feature.getGeometry().getType(), color, text));
  tempLayer.getSource().addFeature(feature);
};

function mapInteraction() {
  let snap = new Snap({
    source: tempLayerSource,
    // pixelTolerance: 25,
    // edge: true,
    // vertex: true
  });
  let draw;
  let onclick;
  let onClickEnabled = false;
  let currentResolve;

  this.draw = (type, options) => {
    return new Promise((resolve) => {
      Notify.info("Haritadan çizim modu etkin", { timeout: 80880 });
      draw = new Draw({
        source: tempLayerSource,
        type,
      });
      MyMap.addInteraction(draw);
      if (options != undefined) {
        MyMap.addInteraction(snap);
        console.log("snap enabled");
      }
      console.log(options.mapkey);
      if (options != undefined && options.mapkey != undefined) {
        if (tempLayerSource.getFeatures().filter((d) => d.get("mapkey") === options.mapkey).length != 0) {
          tempLayerSource.removeFeature(tempLayerSource.getFeatures().filter((d) => d.get("mapkey") === options.mapkey)[0]);
        }
      }
      draw.on("drawend", (evt) => {
        Notify.success("Çizim Yapıldı", {
          showOnlyTheLastOne: true,
        });
        let sketch = evt.feature;
        let feature = new Feature({
          geometry: sketch.getGeometry(),
          tip: sketch.getGeometry().getType(),
        });
        tempLayerSource.addFeature(feature);
        feature.setStyle(styled(feature.getGeometry().getType()));

        MyMap.removeInteraction(draw);
        if (options != undefined) {
          feature.set("mapkey", options.mapkey);
          MyMap.removeInteraction(snap);
        }
        resolve({ status: true, data: sketch });
      });
    });
  };

  this.select = (type, options) => {
    return new Promise((resolve, reject) => {
      if (onClickEnabled) {
        reject("Haritadan Seçme Modu Zaten Aktif!");
        return;
      }
      onClickEnabled = true;

      currentResolve = resolve;
      Notify.info("Haritadan seçme modu etkin!", { timeout: 80800 });
      crosshairCursor(true);
      if (options != undefined && options.mapkey != undefined) {
        if (tempLayerSource.getFeatures().filter((d) => d.get("mapkey") === options.mapkey).length != 0) {
          let hasFeature = tempLayerSource.getFeatures().filter((d) => d.get("mapkey") === options.mapkey)[0];
          tempLayerSource.removeFeature(hasFeature);
        }
      }

      onclick = async (e) => {
        loading();
        await axios
          .get("/adres/getXy/" + type + "/" + e.coordinate[0] + "/" + e.coordinate[1])
          .then((res) => {
            if (res.data.rows != 0) {
              Notify.success("Seçim Yapıldı", {
                showOnlyTheLastOne: true,
              });
              crosshairCursor(false);
              console.log(e.coordinate, type);
              MyMap.un("singleclick", onclick);
              resolve({ status: true, data: res.data.rows });
              if (options == undefined) {
                addFeatureFromGeojson(res.data.rows[0].geojson);
              } else {
                addFeatureFromGeojson(res.data.rows[0].geojson, options.mapkey);
              }
              onClickEnabled = false;
            } else {
              Notify.warning("Tıklanan noktada bilgi bulunamadı. Tekrar tıklama yapabilir ya da ESC ile modu kapatabilirsiniz.");
            }
          })
          .finally(() => {
            removeLoading();
          });
      };
      MyMap.on("singleclick", onclick);
    });
  };

  this.removeInteraction = () => {
    if (onClickEnabled == true) {
      currentResolve({ status: false, data: [] });
      Notify.failure("Seçim modu kapatıldı.", {
        showOnlyTheLastOne: true,
      });
      MyMap.un("singleclick", onclick);
      crosshairCursor(false);
      console.log(MyMap.getListeners());
    }
  };

  document.body.addEventListener("keydown", function (e) {
    if ((e.key == "Escape" || e.key == "Esc" || e.keyCode == 27) && e.target.nodeName == "BODY") {
      if (onClickEnabled == true) {
        currentResolve({ status: false, data: [] });
        Notify.failure("Seçim modu kapatıldı.", {
          showOnlyTheLastOne: true,
        });
        MyMap.un("singleclick", onclick);
        crosshairCursor(false);
        console.log(MyMap.getListeners());
        onClickEnabled = false;
      }
    }
  });
}
export const useMap = new mapInteraction();
